import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import routes from "./RouteList";
import { pushToDataLayer } from "../../utils/gtm";

const PageTracker = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    // Skip tracking for root path — it always immediately redirects
    // (admins → /clients, company users → /dashboard), so the real
    // page_view fires when the destination route renders.
    if (location.pathname === "/") return;

    const matchedRoute = routes.find(
      route =>
        route &&
        matchPath(location.pathname, { path: route.path, exact: route.exact })
    );

    const pageTitle = matchedRoute?.name
      ? t(matchedRoute.name)
      : document.title;

    pushToDataLayer({
      event: "page_view",
      page_path: location.pathname,
      page_title: pageTitle,
    });
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default PageTracker;
